import axios from 'axios';
import { getCookie } from "../../common/util/cookie";
var API2_URL = process.env.REACT_APP_API2_URL;
var Api2 = {
    getUserInfo: function () {
        var url = "".concat(API2_URL, "/api/v1/member/info");
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.get(url, config);
    },
    // getReviewInfo(item_id:any) {
    //     const url = `${API2_URL}/mobile/v1/shopping/items/${item_id}/reviews/info`
    //     const config = {
    //         headers: {'Authorization': `Bearer ${getCookie('auth_token')}`},
    //         withCredentials: true,
    //     }
    //     return axios.get(url, config)
    // },
    getCommentDeclaration: function (item_id) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/notify");
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.get(url, config);
    },
    setReviewCreate: function (item_id, formData) {
        var _a;
        var params = new FormData();
        params.append('marks', formData.grade);
        params.append('message', formData.review);
        if (((_a = formData.chooseFileArr) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            for (var _i = 0, _b = formData.chooseFileArr; _i < _b.length; _i++) {
                var file = _b[_i];
                params.append('images[]', file);
            }
        }
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews");
        var config = {
            headers: {
                'Authorization': "Bearer ".concat(getCookie('auth_token')),
                'Content-Type': 'multipart/form-data',
            },
            withCredentials: true,
        };
        return axios.post(url, params, config);
    },
    setReviewUpdate: function (item_id, review_id, formData) {
        var _a;
        var params = new FormData();
        params.append('marks', formData.grade);
        params.append('message', formData.review);
        params.append('_method', 'PUT');
        if (formData === null || formData === void 0 ? void 0 : formData.modifyImgIndex) {
            for (var _i = 0, _b = formData === null || formData === void 0 ? void 0 : formData.modifyImgIndex; _i < _b.length; _i++) {
                var file = _b[_i];
                params.append('delete_image_indexes[]', file);
            }
        }
        if (((_a = formData.chooseFileArr) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            for (var _c = 0, _d = formData.chooseFileArr; _c < _d.length; _c++) {
                var file = _d[_c];
                params.append('images[]', file);
            }
        }
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/").concat(review_id);
        var config = {
            headers: {
                'Authorization': "Bearer ".concat(getCookie('auth_token')),
                'Content-Type': 'multipart/form-data',
            },
            withCredentials: true,
        };
        return axios.post(url, params, config);
    },
    getReviewDelete: function (item_id, review_id) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/").concat(review_id);
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.delete(url, config);
    },
    setCommentCreate: function (formData) {
        var id = formData.id, message = formData.message, item_id = formData.item_id, idx_thread = formData.idx_thread;
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/").concat(idx_thread, "/comment");
        var params = { idx_b_manager: id, message: message };
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.post(url, params, config);
    },
    setCommentDelete: function (item_id, review_id, comment_id) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/").concat(review_id, "/comment/").concat(comment_id);
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.delete(url, config);
    },
    setCommentUpdate: function (formData) {
        // 아이템id, 리뷰id, 댓글id
        var message = formData.message, item_id = formData.item_id, idx_thread = formData.idx_thread, idx_comment = formData.idx_comment;
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/").concat(idx_thread, "/comment/").concat(idx_comment);
        var params = { message: message };
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.put(url, params, config);
    },
    setReviewDeclaration: function (formData) {
        // item_id:item_id, review_id:review_id, user_id:user_id,comment_id:comment_id,id_notify:reportIndex,ment:message}
        // 아이템id, 리뷰id, 댓글id
        var item_id = formData.item_id, review_id = formData.review_id, id_notify = formData.id_notify, ment = formData.ment;
        /*아이템id, 리뷰id, 코멘트id*/
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/").concat(review_id, "/notify");
        var params = { id_notify: id_notify, ment: ment };
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.post(url, params, config);
    },
    setCommentDeclaration: function (formData) {
        // item_id:item_id, review_id:review_id, user_id:user_id,comment_id:comment_id,id_notify:reportIndex,ment:message}
        // 아이템id, 리뷰id, 댓글id
        var item_id = formData.item_id, review_id = formData.review_id, comment_id = formData.comment_id, id_notify = formData.id_notify, ment = formData.ment;
        /*아이템id, 리뷰id, 코멘트id*/
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/").concat(review_id, "/comment/").concat(comment_id, "/notify");
        var params = { id_notify: id_notify, ment: ment };
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.post(url, params, config);
    },
    setReviewLike: function (item_id, idx_thread) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/").concat(idx_thread, "/like");
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.post(url, {}, config);
    },
    setReviewHate: function (item_id, idx_thread) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/").concat(idx_thread, "/hate");
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.post(url, {}, config);
    },
    getGalleryVideos: function (item_id, page) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/gallery/videos");
        var params = { page: page };
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            params: params,
            withCredentials: true,
        };
        return axios.get(url, config);
    },
    getGalleryImages: function (item_id, page) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/gallery/images");
        var params = { page: page };
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            params: params,
            withCredentials: true,
        };
        return axios.get(url, config);
    },
    getOneReview: function (item_id, review_id) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/reviews/").concat(review_id);
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.get(url, config);
    },
    /*TODO 쇼핑몰 오픈마켓*/
    // https://api2.pping.loc/desktop/v1/shopping/items/{item_id}/market/reviews/info
    getGalleryShoppingVideos: function (item_id, page) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/market/reviews/gallery/videos");
        var params = { page: page };
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            params: params,
            withCredentials: true,
        };
        return axios.get(url, config);
    },
    getGalleryShoppingImages: function (item_id, page) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/market/reviews/gallery/images");
        var params = { page: page };
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            params: params,
            withCredentials: true,
        };
        return axios.get(url, config);
    },
    getOneShoppingReview: function (item_id, review_id) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/market/reviews/").concat(review_id);
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            withCredentials: true,
        };
        return axios.get(url, config);
    },
    /**
     * TODO ↓↓카탈로그
     * */
    getCatalogSpec: function (item_id, idx_b_manager) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/catalog/items");
        var params = { idx_b_manager: idx_b_manager };
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            params: params,
            withCredentials: true,
        };
        return axios.get(url, config);
    },
    getCategoryItemInfo: function (item_id, idx_b_manager) {
        var url = "".concat(API2_URL, "/desktop/v1/shopping/items/").concat(item_id, "/catalog");
        var params = { idx_b_manager: idx_b_manager };
        var config = {
            headers: { 'Authorization': "Bearer ".concat(getCookie('auth_token')) },
            params: params,
            withCredentials: true,
        };
        return axios.get(url, config);
    }
};
export default Api2;



//////////////////
// WEBPACK FOOTER
// ./src/detail/utils/api2.ts
// module id = 8
// module chunks = 0